<template>
  <v-card :dark="$dark()" style="min-width: 800px; max-width: 800px;">
    <v-card-actions>
      <v-btn small all color="success" @click="open_instance">Edit</v-btn>
      <v-btn small color="deep-orange" @click.stop="open_gui" style="min-width: 50px;" dark v-if="have_streamer"><i class="fa fa-cog"></i></v-btn>
      <v-btn small color="deep-orange" @click.stop="open_ssh" style="min-width: 50px;" dark><i class="fa fa-terminal"></i></v-btn>
      <v-btn small color="deep-orange" @click.stop="open_vnc" style="min-width: 50px;" dark><i class="fa fa-tv"></i></v-btn>

      <v-dialog
        width="800"
        v-if="$is_admin()"
        v-model="issuebot_dialog"
        persistent
      >
        <template v-slot:activator="{ on }">
          <v-btn small color="deep-orange" style="min-width: 50px;" dark v-on="on"><i class="fa fa-bug"></i></v-btn>
        </template>
        <v-card>
          <v-card-title
            class="headline grey darken-4"
            primary-title
          >
            Issuebot
            <v-spacer></v-spacer>
            <v-btn icon dark @click="close_issuebot_dialog">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-textarea v-model="issuebot_description" label="Description"></v-textarea>
            <v-textarea v-model="issuebot_command" label="Command" readonly @click="$event.target.select()"></v-textarea>
            <v-textarea v-model="issuebot_result" label="Result" readonly></v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="send_issuebot_command" v-if="issuebot_enabled" :loading="issuebot_running">Send issue</v-btn>
            <v-btn color="blue darken-1" flat @click="close_issuebot_dialog" v-if="!issuebot_enabled" >Close</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>

      <v-btn small color="deep-orange" @click.stop="show_password = !show_password" style="min-width: 50px; margin-left: 8px;" dark v-if="$is_admin()"><v-icon style="font-size: 18px;">lock</v-icon></v-btn>
      <div v-if="$is_admin() && show_password" style="margin-left: 10px; color: #777;">
        {{ssh_password}}
      </div>

      <v-spacer></v-spacer>
      <v-menu bottom right v-if="have_streamer" style="margin-right: 25px;">
        <template v-slot:activator="{ on }">
          <v-btn small icon v-on="on"><v-icon>more_vert</v-icon></v-btn>
        </template>
        <v-list subheader dense>
          <v-subheader>Kepitstreamer</v-subheader>
          <v-divider></v-divider>
          <v-list-tile @click="run_speedtest">
            <v-list-tile-action style="min-width: 30px;">
              <v-icon color="deep-orange">network_check</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Run Speedtest</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="restart_streamer">
            <v-list-tile-action style="min-width: 30px;">
              <v-icon color="deep-orange">restart_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Restart</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="start_streamer" v-if="streamer_status == false">
            <v-list-tile-action style="min-width: 30px;">
              <v-icon color="deep-orange">play_arrow</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Start</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="stop_streamer" v-if="streamer_status == true">
            <v-list-tile-action style="min-width: 30px;">
              <v-icon color="deep-orange">stop</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Stop</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>

          <v-list-tile @click="update_streamer">
            <v-list-tile-action style="min-width: 30px;">
              <v-icon color="deep-orange">update</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Update</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>

        </v-list>
      </v-menu>
      {{version}}
      <v-btn flat small icon @click="$emit('input', false)"><v-icon>close</v-icon></v-btn>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-title >
      <instance-stats :id="instance.id" :small="true" :show_title_and_channel="true" style="min-width: 100%;"></instance-stats>
    </v-card-title>
  </v-card>
</template>

<script>
import InstanceStats from '../instances/Stats'
import InstanceModel from '@/models/instance.js'
import ChannelModel from '@/models/channel.js'
import SettingsModel from '@/models/settings.js'

export default {
  props: ['value', 'instance'],
  components: {
    InstanceStats
  },
  data () {
    return {
      show_password: false,
      issuebot_description: "",
      issuebot_dialog: false,
      issuebot_result: "",
      issuebot_enabled: false,
      issuebot_running: false,
    }
  },
  created() {
    if(this.$is_admin()) {
      this.$store.dispatch("get_profile").then(() => {
        this.issuebot_enabled = true;
      });
    }

  },
  computed: {
    issuebot_command() {
      var description = this.issuebot_description.replaceAll('"','\\"');
      if(this.channel_is_transcoder || InstanceModel.is_type_transcoder(this.instance)) {
        if(this.channel_title_for_instance) {
          description = description + "\n\nChannel title: " + this.channel_title_for_instance;
        }
        return '!cloud "'+this.instance.token+'" "'+description+'"'
      }
      if(!_.isEmpty(this.vpn_ip)) {
        var octets = this.vpn_ip.split(".");
        return '!unit '+octets[2]+'.'+octets[3]+' "'+description+'"'
      }
      return '!issue "' + this.title + '" "' + description + '"';
    },
    have_streamer() {
      return InstanceModel.is_type_transcoder(this.instance) || InstanceModel.is_type_channel(this.instance);
    },
    version() {
      return InstanceModel.version(this.instance);
    },
    channel_title_for_instance () {
      var ch = InstanceModel.channel(this.instance);
      return ChannelModel.title(ch);
    },
    channel_is_transcoder () {
      var ch = InstanceModel.channel(this.instance);
      return ChannelModel.is_transcoder(ch);
    },
    title () {
      return InstanceModel.title(this.instance);
    },
    vpn_ip () {
      return _.get(this.stats, "vpn_ip");
    },
    streamer_status () {
      return _.get(this.stats, "streamer.state", false);
    },
    stats () {
      var st = InstanceModel.status(this.instance.id);
      if (typeof(st) != "undefined") {
        return st.stats;
      }
      return;
    },
    ssh_password() {
      return InstanceModel.ssh_password(this.instance);
    }
  },
  methods: {
    close_issuebot_dialog() {
      this.$nextTick(() => {
        this.issuebot_description = "";
        this.issuebot_result = "";
        this.issuebot_dialog = false;
        this.issuebot_running = false;
        this.issuebot_enabled = true;
      });
    },
    send_issuebot_command() {
      if(!this.$is_admin()) return;
      var settings = SettingsModel.get_by_name("issuebot");
      var apikey = _.get(settings, "value.apikey");
      var host = _.get(settings, "value.host");

      if(_.isEmpty(apikey) || _.isEmpty(host) || !this.issuebot_enabled) {
        this.$message.error("Unable to create issue!");
        return;
      }
      this.issuebot_running = true;

      this.issuebot_result = "";
      var acc = this.$store.state.account;

      var ws = new WebSocket("wss://"+host+"/issuebot?token="+apikey)
      ws.onopen = () => {
        ws.send(JSON.stringify({command: this.issuebot_command, user: acc.email, name: acc.name || acc.email}));
      }
      ws.onmessage = (event) => {
        try {
          var data = JSON.parse(event.data);
        } catch(err) {
          return;
        }

        if(data.type == "reply") {
          this.issuebot_result += data.message + "\n";
        }
        if(data.type == "ready") {
          this.$message.success("Issue created successfully!");
          ws.close();
          this.issuebot_enabled = false;
        }
      }
      ws.onerror = (err) => {
        this.$message.error("Unable to create issue!");
        this.issuebot_enabled = false;
      }
    },
		open_instance () {
      this.$router.push("/dashboard/instance/" + this.instance.id);
		},
    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
    open_ssh() {
      if (InstanceModel.ssh_url(this.instance) != "") {
        window.location.href = InstanceModel.ssh_url(this.instance);
      }
    },
    open_vnc() {
      if (InstanceModel.vnc_url(this.instance) != "") {
        window.location.href = InstanceModel.vnc_url(this.instance);
      }
    },
    restart_streamer() {
      if(!confirm("Do you really want restart streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.restart_streamer(this.instance, (msg) => {
				self.$message.success("Streamer restart success");
			}, (err) => {
				self.$message.error("Streamer restart failed");
			});
    },
    start_streamer() {
      if(!confirm("Do you really want start streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.start_streamer(this.instance, (msg) => {
				self.$message.success("Streamer start success");
			}, (err) => {
				self.$message.error("Streamer start failed");
			});
    },
    stop_streamer() {
      if(!confirm("Do you really want stop streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
			var self = this;
			InstanceModel.stop_streamer(this.instance, (msg) => {
				self.$message.success("Streamer stop success");
			}, (err) => {
				self.$message.error("Streamer stop failed");
			});
    },
    update_streamer() {
      if(!confirm("Do you really want update streamer?\nInstance: "+this.title+"\nChannel: "+this.channel_title_for_instance)) return;
      var self = this;
      InstanceModel.update_streamer(this.instance, (msg) => {
        self.$message.success("Streamer update request sent");
      }, (err) => {
        self.$message.error("Streamer update request failed");
      });
    },
    run_speedtest() {
      var self = this;
      InstanceModel.send_streamer(this.instance, {"type": "speedtest"}, (msg) => {
        self.$message.success("Streamer speedtest started");
      }, (err) => {
        self.$message.error("Streamer speedtest failed");
      });
    }

  }
}
</script>
